import { useButton } from '@react-aria/button'
import { PropsWithChildren, useRef } from 'react'
import Styles from './BottomItem.module.scss'
import { Icon } from 'blaze-ui/icons/Types'
import { PressProps, useHover } from '@react-aria/interactions'
import { useFocusRing } from '@react-aria/focus'
import { mergeProps } from '@react-aria/utils'
import cx from 'classnames'
import { LinkProps, NavLink } from 'react-router-dom'

export const BottomItem = ({ icon: Icon, children, ...pressProps }: PropsWithChildren<{ icon: Icon } & PressProps>) => {
  const ref = useRef<HTMLButtonElement>(null)
  const { buttonProps } = useButton(pressProps, ref)
  const { isHovered, hoverProps } = useHover({})
  const { isFocusVisible, focusProps } = useFocusRing()

  return (
    <button
      ref={ref}
      {...mergeProps(buttonProps, hoverProps, focusProps)}
      className={cx(Styles.root, {
        [Styles.hovered]: isHovered,
        [Styles.focusVisible]: isFocusVisible,
      })}
    >
      <div className={Styles.icon}>
        <Icon size={16} />
      </div>
      <span className={Styles.text}>{children}</span>
    </button>
  )
}

export const BottomItemLink = ({
  icon: Icon,
  children,
  ...navProps
}: PropsWithChildren<{ icon: Icon } & LinkProps>) => {
  const { isHovered, hoverProps } = useHover({})
  const { isFocusVisible, focusProps } = useFocusRing()

  return (
    <NavLink
      {...mergeProps(navProps, hoverProps, focusProps)}
      className={cx(Styles.root, {
        [Styles.hovered]: isHovered,
        [Styles.focusVisible]: isFocusVisible,
      })}
    >
      <div className={Styles.icon}>
        <Icon size={16} />
      </div>
      <span className={Styles.text}>{children}</span>
    </NavLink>
  )
}

export const BottomItemExternalLink = ({
  icon: Icon,
  children,
  ...navProps
}: PropsWithChildren<{ icon: Icon } & React.AnchorHTMLAttributes<HTMLAnchorElement>>) => {
  const { isHovered, hoverProps } = useHover({})
  const { isFocusVisible, focusProps } = useFocusRing()

  return (
    <a
      {...mergeProps(navProps, hoverProps, focusProps)}
      className={cx(Styles.root, {
        [Styles.hovered]: isHovered,
        [Styles.focusVisible]: isFocusVisible,
      })}
    >
      <div className={Styles.icon}>
        <Icon size={16} />
      </div>
      <span className={Styles.text}>{children}</span>
    </a>
  )
}
